import { onAuthStateChanged, signOut } from "firebase/auth";
import React, { useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { COLLECTION_NAME } from "../constants/endpoints";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDocRef = doc(db, COLLECTION_NAME.users, user.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            setUserRole(userDoc.data().isAdmin === true ? "admin" : "user");
          } else {
            setUserRole("user");
          }
        } catch (error) {
          console.error("Error checking admin status:", error);
          setUserRole("user");
        }
      } else {
        setUserRole(null);
      }

      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const logout = () => {
    setUserRole(null);
    setCurrentUser(null);
    return signOut(auth);
  };

  const isAdmin = () => {
    return userRole === "admin";
  };

  const value = {
    currentUser,
    userRole,
    isAdmin,
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

